import 'vuetify/styles'
import { createVuetify } from 'vuetify'

// Tema plano/minimalista (fondo blanco, sin elevación, bordes simples),
// inspirado en el harness de testing index-gui.html.
export default createVuetify({
    theme: {
        themes: {
            light: {
                colors: {
                    primary: '#424242',
                    background: '#FFFFFF',
                    surface: '#FFFFFF',
                }
            }
        }
    },
    defaults: {
        VBtn: {
            variant: 'outlined',
            rounded: 'sm',
        },
        VTextField: {
            variant: 'outlined',
            density: 'compact',
        },
        VSelect: {
            variant: 'outlined',
            density: 'compact',
        },
        VAutocomplete: {
            variant: 'outlined',
            density: 'compact',
        },
        VCombobox: {
            variant: 'outlined',
            density: 'compact',
        },
        VTextarea: {
            variant: 'outlined',
            density: 'compact',
        },
        VAppBar: {
            color: 'grey-lighten-4',
            elevation: 0,
        },
        VFooter: {
            color: 'grey-lighten-4',
            elevation: 0,
        },
        VCard: {
            variant: 'outlined',
        },
        VSheet: {
            elevation: 0,
        },
        VNavigationDrawer: {
            elevation: 0,
        },
    }
})
